<h2>Register Firm</h2>
<app-select-firm-type [availables]="availables" (typeSelected)="onTypeSelected($event)" (cancel)="onCancel()">
</app-select-firm-type>
